import useRotas from "@/Composables/useRotas";

export default function useGerarImagem() {
    const route = useRotas();
    return (
        id,
        largura = null,
        altura = null,
        alinhamento = null,
        marca_dagua = null,
        carimbo = null,
        formato = "webp"
    ) => {
        return route("midia.arquivo", {
            idArquivo: id,
            largura: largura,
            altura: altura,
            alinhamento: alinhamento,
            marca_dagua: marca_dagua,
            carimbo: carimbo,
            formato: formato,
        });
    };
}
